<div class="modal-header">
	<h4 class="modal-title">{{ 'countrySelectDialog.modalTitle' | translate }}</h4>
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<cfe-icon [iconName]="'close'"></cfe-icon>
	</button>
</div>

<div class="modal-body">
	<form *ngIf="form">
		<div class="country-selection">
			<div class="country-group" *ngFor="let item of formStructure">
				<h4>{{ item.group }}</h4>
				<ng-container *ngFor="let country of item.countries">
					<cfe-input-checkbox-small
						[control]="form.get(country.code)"
						[label]="getCountryLabel(country.code)"
						[id]="'country' + country.code"
					></cfe-input-checkbox-small>
				</ng-container>
			</div>
		</div>
	</form>
</div>

<div class="modal-footer">
	<button class="btn btn-outline-primary" (click)="selectAll()" [disabled]="areAllCountriesSelected">
		{{ 'countrySelectDialog.selectAll' | translate }}
	</button>
	<button class="btn btn-outline-primary" (click)="clear()" [disabled]="isOnlyUsersCountrySelected">
		{{ 'countrySelectDialog.clear' | translate }}
	</button>
	<button class="btn btn-primary" (click)="apply()" [disabled]="!hasChanges">{{ 'countrySelectDialog.apply' | translate }}</button>
</div>
